import React, { useEffect, useState } from "react";
import { Form, Table, Button, Image } from "react-bootstrap";
import SelectFilter from "../../../reusableComponents/selectFilter";

import axios from "axios";
import isEmpty from "../../../../store/validation/is-Empty";
import { useSelector } from "react-redux";
import { ORDER_TYPE } from "../../../../enums/OrderEnums";
import moment from "moment";
import { serverApi } from "../../../../config/Keys";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import BasicPagination from "../../../Pagination/Pagination";
import ReadMoreReact from "read-more-react/dist/components/ReadMoreReact";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { TextField } from "@material-ui/core";
import Alert from "react-s-alert";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";

const assignedTo = [
  "Sai Nitish Bimari",
  "Gaurav Shinde",
  "Naveen Vedala",
  "Teja Raavi",
  "Miraj koradiya",
  "Meena Bagwan",
  "Abhay Thorat",
  "Saamanth",
];

const SuperAdminErrorLogs = (props) => {
  const [taxData, setTaxData] = useState([]);
  const [taxStat, setTaxStat] = useState({});
  const [search, setSearch] = useState("");
  const [dateQuery, setDateQuery] = useState({});

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
    //page = pageNo;
  };

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      getReportData("tax", dateQuery);
    }
  }, [auth]);

  const getReportData = async (type, dateQuery) => {
    let data = await axios.get(`${serverApi}/errorHandler`, {
      params: { ...dateQuery },
      headers: {
        Authorization: auth.accessToken,
        "Content-Type": "application/json",
      },
    });
    if (data.data) {
      setTaxData(data.data);
      //   setTaxStat(data.data.stats[0]);
    }
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
    getReportData("tax", data);
  };

  const renderData = taxData.filter((item) => {
    return (
      item.source.toLowerCase().includes(search.toLowerCase()) ||
      item.status.toLowerCase().includes(search.toLowerCase()) ||
      item._id.toLowerCase().includes(search.toLowerCase())
    );
  });

  const key = "stack";

  const arrayUniqueByKey = [
    ...new Map(renderData.map((item) => [item[key], item])).values(),
  ];

  //download data

  const downloadData = {
    headers: [
      { label: "Error Id", key: "id" },
      { label: "Source", key: "source" },
      { label: "Assigned To", key: "assignedto" },
      { label: "Description", key: "description" },
      { label: "Status", key: "status" },
      { label: "Date Time", key: "dateandtime" },
    ],
    data: arrayUniqueByKey
      ? arrayUniqueByKey?.map((ele) => {
          return {
            id: ele?._id,
            source: ele?.source,
            assignedto: ele?.assignedTo,
            description: ele?.stack || "",
            status: ele?.status,
            dateandtime: `${moment(ele?.createdAt).format("ll")}\n ${moment(
              ele?.createdAt
            ).format("LT")}`,
          };
        })
      : [],
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Error Logs</div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="amSearch"
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../../assets/images/iconButton/sorticon.png")}
                        width="35px"
                        alt="Sort Icon"
                      />
                      <br />
                      Sort
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                        alt="Filter Icon"
                      />
                      <br />
                      Filter
                    </div>
                    <div className="f10-400" align="center">
                      <CSVDownloader
                        filename={"Error Logs"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "10%" }} className="f12-700">
                          Error Id
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Source
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Assigned To
                        </th>
                        <th style={{ width: "40%" }} className="f12-700">
                          Description
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Status
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Date Time
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Action
                        </th>
                      </tr>
                    </thead>

                    {renderData &&
                      arrayUniqueByKey &&
                      arrayUniqueByKey.slice(start, end).map((data) => (
                        <tbody>
                          <tr
                            className="super_admin_all_users_table_body"
                            style={{
                              lineBreak: "anywhere",
                            }}
                          >
                            <td style={{ width: "10%" }} className="f12-500">
                              {data?._id}
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {data?.source}
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {data?.assignedTo}
                            </td>
                            <td style={{ width: "40%" }} className="f12-500">
                              <div
                                id="read-more-text"
                                className="f10-500 opacity5"
                              >
                                <ReadMoreReact
                                  text={data?.stack || ""}
                                  min={0}
                                  ideal={0}
                                  max={data.stack && data.stack.length}
                                  readMoreText={"Read More"}
                                />
                              </div>
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {data?.status}
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {moment(data?.createdAt).format("ll")}
                              <br />
                              {moment(data?.createdAt).format("LT")}
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              <div className="d-flex">
                                <ChangeStatus
                                  data={data}
                                  successChange={() =>
                                    getReportData("", dateQuery)
                                  }
                                />
                                <AssignedToModal
                                  data={data}
                                  successChange={() =>
                                    getReportData("", dateQuery)
                                  }
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </Table>
                </div>
                <BasicPagination
                  totalRecords={renderData?.length || 0}
                  limit={10}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SuperAdminErrorLogs;

const ChangeStatus = (props) => {
  const [open, setOpen] = React.useState(false);
  let status = 0;

  if (props?.data?.status === "NEW") {
    status = 0;
  } else if (props?.data?.status === "IN PROGRESS") {
    status = 1;
  } else if (props?.data?.status === "CLOSED") {
    status = 2;
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const onSuccess = () => {
    Alert.success(`<h4>Status changed successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    props.successChange();
  };

  const changeStatusFun = async (e) => {
    let sendStatus = "NEW";
    if (e === 1) {
      sendStatus = "IN PROGRESS";
    } else if (e === 2) {
      sendStatus = "CLOSED";
    }
    const result = await axios.patch(
      `${serverApi}/errorHandler/${props?.data?._id}`,
      { status: sendStatus },
      {
        headers: {
          Authorization: auth.accessToken,
          "Content-Type": "application/json",
        },
      }
    );
    if (result.data) {
      handleClose();
      onSuccess();
    }
  };

  return (
    <div>
      <Image
        src={require("../../../../assets/images/OfferAndEventImages/edit.png")}
        alt="View Icon"
        title="View Profile"
        fluid
        onClick={handleClickOpen}
      />
      {/* require("../../../../assets/images/OfferAndEventImages/view.png") */}
      {/* <Button variant="outlined" color="primary">
        Change status
      </Button> */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Change status</DialogTitle>
        <DialogContent>
          <Button
            onClick={() => {
              changeStatusFun(0);
            }}
            variant={status === 0 ? "danger" : "primary"}
            className="mr-2"
          >
            New
          </Button>
          <Button
            onClick={() => {
              changeStatusFun(1);
            }}
            variant={status === 1 ? "danger" : "primary"}
            className="mr-2"
            autoFocus
          >
            In progress
          </Button>
          <Button
            onClick={() => {
              changeStatusFun(2);
            }}
            variant={status === 2 ? "danger" : "primary"}
            className="mr-2"
          >
            Closed
          </Button>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  );
};

const AssignedToModal = (props) => {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const onSuccess = () => {
    Alert.success(`<h4>Assigned successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    props.successChange();
  };

  const changeStatusFun = async (e) => {
    const result = await axios.patch(
      `${serverApi}/errorHandler/${props?.data?._id}`,
      { assignedTo: value },
      {
        headers: {
          Authorization: auth.accessToken,
          "Content-Type": "application/json",
        },
      }
    );
    if (result.data) {
      handleClose();
      onSuccess();
    }
  };

  return (
    <div>
      <Image
        src={require("../../../../assets/images/OfferAndEventImages/view.png")}
        alt="View Icon"
        title="Assigned to"
        fluid
        onClick={handleClickOpen}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Assign to</DialogTitle>
        <DialogContent>
          <TextField
            label="Assigned to"
            variant="outlined"
            fullWidth
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          <Button
            onClick={() => {
              changeStatusFun(0);
            }}
            variant={value ? "danger" : "primary"}
            className="mt-2 "
          >
            Submit
          </Button>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  );
};
